import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1',
    display: 'grid',
    gridTemplateColumns: `minmax(100px, 1fr) auto`
  },

  title: {
    marginTop: '0'
  },

  name: {
    overflow: 'hidden',
    fontSize: theme.size.sm,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    userSelect: 'none'
  },

  modalName: {
    maxWidth: 'unset !important'
  },

  content: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    marginTop: '8px',
    height: 'unset',
    width: 'auto',
    paddingRight: '5px'
  },

  modalContent: {
    width: 'unset !important'
  },

  contentBlock: {
    flex: '1'
  },

  smallButtons: {
    display: 'flex'
  },

  controlsBlock: {
    display: 'flex',
    alignItems: 'flex-end'
  },

  time: {
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  }
}))

export default useStyles
